// @ts-strict-ignore
import { useEffect, useRef } from 'react';
import { useTheme } from '@mui/material';
import * as d3 from 'd3';

type SimpleDonutChartProps = {
    value: number;
    // zero means auto
    size?: number;
    strokeWidth?: number;
    backgroundColor?: string;
    color?: string;
    gapColor?: string;
    gapWidth?: number;
};

export function SimpleDonutChart(props: SimpleDonutChartProps) {
    const svgRef = useRef<SVGSVGElement>();
    const twoPi = 2 * Math.PI;
    const theme = useTheme();

    const {
        value,
        size = 24,
        strokeWidth,
        backgroundColor = theme.palette.mode === 'dark'
            ? theme.bino.color.darkerGray
            : theme.bino.color.lightGray,
        color = theme.bino.color.primary,
        gapColor = theme.bino.color.white,
        gapWidth = 2,
    } = props;
    //let progress = 0;

    useEffect(() => {
        //Dont Display anything if rating is a "NaN" or null
        if (null === value || undefined === value || Number.isNaN(value)) {
            return;
        }
        if (!svgRef.current) {
            return;
        }
        const svg = d3.select(svgRef.current);
        svg.selectAll('g').remove();

        let radius = size;
        if (radius === 0) {
            svg.attr('width', 0); // To be able to recalculate a new height dynamically. Maybe there is a better way?
            svg.attr('height', 0);
            const parentWidth = svgRef.current.parentElement.clientWidth;
            const parentHeight = svgRef.current.parentElement.clientHeight;
            if (parentWidth === 0 || parentHeight === 0) {
                return;
            }
            radius = Math.min(parentWidth, parentHeight);
        }
        const newStrokeWidth = strokeWidth || Math.max(4, size * 0.045);

        svg.attr('width', radius).attr('height', radius);
        const g = svg
            .append('g')
            .attr(
                'transform',
                'translate(' + radius / 2 + ',' + radius / 2 + ')',
            );

        // g
        // .append("rect")
        // .attr("width", "100%")
        // .attr("height", "100%")
        // .attr("fill", "pink");

        const arc = d3
            .arc()
            .startAngle(0)
            .innerRadius(radius / 2 - newStrokeWidth)
            .outerRadius(radius / 2);
        //.cornerRadius(size * 0.2)
        //.endAngle(Math.PI / 2)
        const arc2 = d3
            .arc()
            .innerRadius(radius / 2 - newStrokeWidth)
            .outerRadius(radius / 2);
        g.append('path') //.attr("d", arc.endAngle(twoPi))
            .datum({
                endAngle: twoPi,
            })
            .attr('fill', backgroundColor) // .attr("stroke", theme.color.white)
            // .attr("stroke-width", gap)
            .attr('d', arc);

        if (Math.round(value * 100) / 100 !== 0) {
            g.append('path')
                .datum({
                    startAngle: twoPi * 0.011,
                    endAngle: twoPi * (value - value * 0.011), // todo FIX, CAN BE SOLVED DIFFERENTLY
                })
                .style('fill', color) // .style("stroke", theme.color.white )
                // .style("stroke-width", gap )
                .attr('d', arc2);

            if (gapWidth > 0) {
                // Probably slightly more efficient to just draw a line, and we dont have to use gapWidth / 2
                [twoPi, twoPi * value].forEach((angle) => {
                    g.append('path')
                        .datum({
                            startAngle: angle,
                            endAngle: angle,
                        })
                        .style('stroke', gapColor)
                        .style('stroke-width', gapWidth * 0.5 + 'px')
                        .attr('d', arc2);
                });
            }

            //
            // g.append("path")
            //     .datum({
            //         endAngle: twoPi * value,
            //         startAngle: twoPi * (value - (value * 0.01))
            //     })
            //     .style("fill", theme.color.white )
            //     .attr("d", arc2);
        }
    }, [
        value,
        size,
        strokeWidth,
        backgroundColor,
        color,
        gapColor,
        gapWidth,
        twoPi,
    ]);

    return <svg ref={svgRef} width="100%" height="100%" overflow="visible" />;
}

export default SimpleDonutChart;
